import { useContext } from "react";

import { Navigate } from "react-router";

import AuthContext from "context/auth/authContext";
import { ROUTES } from "shared/types/enums";

import EnableTwoFactorAuthentication from "./EnableTwoFactorAuthentication";

const TwoFactorRequirement = () => {
    const { isAuthenticated } = useContext(AuthContext);

    return isAuthenticated ? (
        <EnableTwoFactorAuthentication />
    ) : (
        <Navigate to={{ pathname: ROUTES.Login }} replace />
    );
};

export default TwoFactorRequirement;
